import { useEffect } from "react";
import { registerCekresiWebMCPTools } from "../utils/webMcp";

/**
 * WebMcpProvider automatically registers Cekresi WebMCP tools on window.document.modelContext
 * when the application mounts in the browser.
 */
export default function WebMcpProvider({ children }) {
  useEffect(() => {
    registerCekresiWebMCPTools();
  }, []);

  return children || null;
}
